module.exports = __webpack_public_path__ + "img/medalla1.871b564b.png";